import React from "react";

const lessonRequirements = (props) => {
  const { AcceptLessonModalOpen ,InitialDeclineModalOpen} = props;
  return (
    <React.Fragment>
      {/* <!-- requirements --> */}
      <section className="requirements">
        <h4 className="py-2">Lesson requirements:</h4>
        <p className="py-2" style={{ marginBottom: "0px" }}>
          I love to teach. Helping students understand complicated concepts and
          ideas of course, their worthwhile. I graduated from university of
          liverpool, Liverpool with B.SC. in Mathematics with tutor, teaching
          mathemtaics and bussiness-related subjects in GCSE and A level of
          students
        </p>
        <p className="pointer" style={{ color: "#2cb46d" }}>
          Read more
        </p>
        {/* <!--btns--> */}
        <a
          className="btn btn-success accept-btn mx-auto flex-center-center w-100 py-3 my-4"
          href="#"
          onClick={AcceptLessonModalOpen}
        >
          Accept
        </a>
        <a
          className="btn btn-otline-success mx-auto flex-center-center w-100 py-3 my-4 decline"
          href="#"
          onClick={InitialDeclineModalOpen}
        >
          Decline
        </a>
      </section>
      <hr></hr>

      {/* <!--question/Help --> */}
      <section className="question-container">
        <h4 className="py-2">
          Do you have any queries or questions about this lesson request?
        </h4>
        <p className="pointer" style={{ color: "#2cb46d" }}>
          {" "}
          Send message
        </p>
      </section>
      <hr></hr>
    </React.Fragment>
  );
};
export default lessonRequirements;
